import './css/styles.scss';
import * as Home from './container/home';
import * as Products from './container/products';
import * as ViewProducts from './container/view-products';
import * as ViewSupplier from './container/view-supplier';
import * as ShoppingList from './container/shopping-list';
import * as Contact from './container/contact';
import * as PrivacyPolicy from './container/privacy-policy';
import * as Agents from './container/agents';
import * as Events from './container/events';
import * as SocialResponsibility from './container/social-responsibility';
import * as SearchResults from './container/search-results';
import * as ProductStores from './container/stores';
import * as Collections from './container/collections';
import * as ShoppingListStores from './container/shopping-list-stores';
import * as StoreLocator from './container/store-locator';
import * as Faq from './container/faq';
import * as StoreProducts from './container/supplier-products';
import * as ReactHabitat from 'react-habitat';
const redux:any = require('redux');
const createStore:any = redux.createStore;
import ReduxDomFactory from './ReduxDomFactory';
import reducers from './reducers';
import '@babel/polyfill';


class MyApp extends ReactHabitat.Bootstrapper {
    constructor(){
        super();

        // Create a new container builder
        const builder = new ReactHabitat.ContainerBuilder();
        // Create a redux store
		const store = createStore(
            reducers,
            {
                authenticated: false,
                shoppingList: [],
                favoriteStores: [],
                signInModal: false,
                signInFromHeader: false,
                mapLoading: false
              },
            (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
             (window as any).__REDUX_DEVTOOLS_EXTENSION__()
		);

		// Set the container to use our redux factory
		builder.factory = new ReduxDomFactory(store);

        // Register a component
        builder.register(Home).as('Home');
        builder.register(Products).as('Products');
        builder.register(ViewProducts).as('ViewProducts');
        builder.register(ViewSupplier).as('ViewSupplier');
        builder.register(ShoppingList).as('ShoppingList');
        builder.register(Contact).as('Contact');
        builder.register(PrivacyPolicy).as('PrivacyPolicy');
        builder.register(SocialResponsibility).as('SocialResponsibility');
        builder.register(SearchResults).as('SearchResults');
        builder.register(Agents).as('Agents');
        builder.register(Events).as('Events');
        builder.register(Collections).as('Collections');
        builder.register(ProductStores).as('ProductStores');
        builder.register(ShoppingListStores).as('ShoppingListStores');
        builder.register(StoreLocator).as('StoreLocator');
        builder.register(StoreProducts).as("StoreProducts");
        builder.register(Faq).as("Faq");
         
        // Finally, set the container
        this.setContainer(builder.build());
    }
}

// Always export a 'new' instance so it immediately evokes
export default new MyApp();
